import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {AiSettingsComponent} from './ai-settings.component';
import {LocalStoreService} from '../../../services';
import {MatButtonModule} from '@angular/material/button';
import {CommonModule} from '@angular/common';
import {DragDropModule} from '@angular/cdk/drag-drop';

@Component({
    selector: 'app-ai-settings-dialog',
    standalone: true,
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        AiSettingsComponent,
        DragDropModule
    ],
    templateUrl: './ai-settings-dialog.component.html',
    styleUrls: ['./ai-settings-dialog.component.scss']
})
export class AiSettingsDialogComponent {
    aiSettings: any;
    originalSettings: any;

    constructor(
        public dialogRef: MatDialogRef<AiSettingsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private localStoreService: LocalStoreService
    ) {
        this.aiSettings = data || this.localStoreService.getStorageValConfig('ai') || {};
        this.originalSettings = {...this.aiSettings};
    }

    onAiSettingsChange(settings: any) {
        this.aiSettings = settings;
    }

    onCancel() {
        // Restore original settings
        this.localStoreService.setStorageValConfig('ai', this.originalSettings);
        this.dialogRef.close();
    }

    onSave() {
        // Save settings
        this.localStoreService.setStorageValConfig('ai', this.aiSettings);
        this.dialogRef.close(this.aiSettings);
    }
}
